import React, { useMemo } from 'react';
import IconFlightActive from '@/assets/IconFlightActive.svg';
import IconFlight from '@/assets/IconFlight.svg';

import { Button } from '@/components/global/Button';

import { TCard } from '@/services/requests/Recommendation/types/template4';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';
import { isHttpLink } from '@/helpers/StringHelper/isHttpLink';
import { getCTA } from '@/helpers/CtaHelper';
import { getValue } from '@/helpers/GetValueHelper';

type TProps = {
  data: TCard;
  onClick: (event: React.MouseEvent<HTMLAnchorElement>, cardId: string) => void;
};

export const CardAereo = React.memo(({ data, onClick }: TProps) => {
  const { id, icon, title, task_status, detail } = data;
  const link = getCTA(data.cta, 'web')?.link || '';

  const styleCardLink = useMemo(() => {
    return link ? { cursor: 'pointer' } : { cursor: 'default' };
  }, [link]);

  const formattedLink = useMemo(() => {
    return isHttpLink(link) ? link : undefined;
  }, [link]);

  const parsedCurrentValue = parseInt(
    getValue(detail, 'current_value', '0') as string,
    10,
  );
  const parsedTotalValue = parseInt(
    getValue(detail, 'total_value', '0') as string,
    10,
  );

  const isDone = task_status === 'complete';

  const statusClassName = isDone ? 'vitrine-template4__card--checked' : '';

  const configButton = isDone
    ? {
        text: 'Concluído',
        className: 'vitrine-template4__card-button-aereo--done',
      }
    : {
        text: 'Resgatar passagem',
        className: 'vitrine-template4__card-button-aereo',
        isOutlined: true,
      };

  return (
    <a
      href={formattedLink}
      title={clearHtmlTags(title)}
      className={`vitrine-template4__card ${statusClassName}`}
      key={id}
      data-id={id}
      onClick={e => onClick(e, id)}
      style={styleCardLink}
      data-testid="card"
    >
      <img
        className="vitrine-template4__card-icon"
        src={icon}
        alt={clearHtmlTags(title)}
        data-testid="card-icon"
        width={24}
        height={24}
      />
      <span
        className="vitrine-template4__card-title"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <div className="vitrine-template4__card-aereo">
        {[...new Array(parsedTotalValue).keys()].map(item => {
          const isActive = item + 1 <= parsedCurrentValue;
          const iconFlight = isActive ? IconFlightActive : IconFlight;
          return <img key={item} src={iconFlight} alt="Flight" />;
        })}
      </div>
      <div className="vitrine-template4__card-footer">
        <Button
          text={configButton.text}
          className={configButton.className}
          isOutlined={configButton.isOutlined}
          isPill
        />
      </div>
    </a>
  );
});
